module.exports = __webpack_public_path__ + "img/organization-asset-group2.7c0eb046.png";